import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

const possiblyDeletedCheckoutExperienceSchema = z.union([
  z.object({ _id: zExt.objectId(), name: z.string() }),
  z.object({ _id: zExt.objectId(), deleted: z.literal(true) }),
]);
export type PossiblyDeletedCheckoutExperience = z.infer<
  typeof possiblyDeletedCheckoutExperienceSchema
>;

const baseSplitInfoSchema = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  active: z.boolean(),
  createdAt: z.date(),
  controlCheckoutExperiences: z.array(possiblyDeletedCheckoutExperienceSchema),
  experimentCheckoutExperiences: z.array(
    possiblyDeletedCheckoutExperienceSchema,
  ),
  metricToOptimize: z.nativeEnum(CheckoutAbTestMetricToOptimize),
});

const concludedSplitInfoSchema = baseSplitInfoSchema.extend({
  active: z.literal(false),
  concludedAt: z.date().optional(),
});
export type ConcludedSplitInfo = z.infer<typeof concludedSplitInfoSchema>;

const activeSplitInfoSchema = baseSplitInfoSchema.extend({
  active: z.literal(true),
});
export type ActiveSplitInfo = z.infer<typeof activeSplitInfoSchema>;

export const getConcludedAndActiveCheckoutSplits = {
  input: z.null(),
  output: z.object({
    concludedSplits: z.array(concludedSplitInfoSchema),
    activeSplits: z.array(activeSplitInfoSchema),
  }),
};
export type GetConcludedAndActiveCheckoutSplitsOutput = z.infer<
  typeof getConcludedAndActiveCheckoutSplits.output
>;
